
import type { PropType } from 'vue'
import type { ToolLayoutMessages } from '../../models/i18n/tools.messages'
import { defineComponent, inject } from 'vue'

import { mapActions, mapGetters } from 'vuex'
import { CONTEXT_CONSTS } from '../../store/context/context.consts'
import { EpbText } from '../shared'
import { EpbButton } from '../shared/epb-button'

export default defineComponent({
  name: 'NoDataFound',
  components: {
    EpbButton,
    EpbText,
  },
  props: {
    messages: {
      type: Object as PropType<Pick<ToolLayoutMessages, 'noDataFound' | 'dataFiltered'>>,
      required: true,
    },
    imgSrcName: {
      type: String,
      default: 'satelite.webp',
    },
  },
  setup() {
    const hideClearFiltersButton = inject('hideClearFiltersButton', false)
    return { hideClearFiltersButton }
  },
  data() {
    return { baseClass: 'no-data-found' }
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      appliedFiltersCount: CONTEXT_CONSTS.getters.appliedFiltersCount,
    }),
    computedImgSrc(): string {
      return require(`../../assets/media/image/tooling/${this.imgSrcName}`)
    },
    showClearFiltersButton(): boolean {
      return this.appliedFiltersCount > 0 && !this.hideClearFiltersButton
    },
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      clearFilters: CONTEXT_CONSTS.actions.clearFilters,
    }),
    async onClearFilters() {
      await this.clearFilters()
      this.$router.replace({
        ...this.$route,
        name: this.$route.name,
      })
    },
  },
})
